import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ShieldCheck, Mail, Lock, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { MField, MInput } from './adminUI';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/admin/login', { email, password });
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_name', res.data.admin.name);
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="flex min-h-screen items-center justify-center bg-background p-4 font-sans">
      <div className="w-full max-w-sm overflow-hidden rounded-3xl border border-border bg-card shadow-xl">
        <div className="flex flex-col items-center px-8 pb-2 pt-10 text-center">
          <span className="mb-4 flex size-14 items-center justify-center rounded-2xl bg-brand text-brand-foreground shadow-lg">
            <ShieldCheck className="size-7" />
          </span>
          <h2 className="m-0 text-xl font-black tracking-tight text-foreground">ورود ادمین</h2>
          <p className="mb-0 mt-1 text-[13px] text-muted-foreground">پنل مدیریت فروشگاه</p>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-3.5 p-8 pt-5">
          <MField label="ایمیل">
            <div className="relative">
              <Mail className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
              <MInput type="email" value={email} onChange={e => setEmail(e.target.value)} required dir="ltr"
                className="pr-9 text-left" placeholder="admin@shop.ir" />
            </div>
          </MField>
          <MField label="رمز عبور">
            <div className="relative">
              <Lock className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
              <MInput type="password" value={password} onChange={e => setPassword(e.target.value)} required dir="ltr"
                className="pr-9 text-left" placeholder="••••••••" />
            </div>
          </MField>
          {error && (
            <div role="alert" className="rounded-xl bg-destructive/10 px-3.5 py-2.5 text-[13px] font-semibold text-destructive">
              {error}
            </div>
          )}
          <Button type="submit" variant="brand" size="lg" className="mt-1 w-full rounded-full" disabled={loading}>
            {loading ? 'در حال ورود...' : (<>ورود به پنل <ArrowLeft className="size-4" /></>)}
          </Button>
        </form>
      </div>
    </div>
  );
}
